module.exports = __webpack_public_path__ + "img/ardoise_noir_gros_diametre.c690c0b4.jpg";